/**
 * @file PrivacyConsentCheckbox.tsx
 * @description Component for rendering a privacy consent checkbox.
 * Handles the state of the checkbox and triggers a callback on change.
 */

import React from "react";

interface PrivacyConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

// Constants for consent information
const CONSENT_VERSION = "v1.0";
const CONSENT_METHOD = "online_form";
const CONSENT_PURPOSE = "marketing, analytics";

const PrivacyConsentCheckbox: React.FC<PrivacyConsentCheckboxProps> = ({
  checked,
  onChange,
}) => (
  <label className="items-start gap-3 pb-4 mb-4 text-sm cursor-pointer label">
    <input
      type="checkbox"
      id="privacy-consent"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      required
      className="checkbox"
    />
    <span className="text-left normal-case label-text">
      Ho letto l’informativa privacy e acconsento alla memorizzazione dei miei
      dati nel vostro archivio secondo quanto stabilito dal regolamento europeo
      per la protezione dei dati personali n. 679/2016, GDPR.
    </span>
  </label>
);

export default PrivacyConsentCheckbox;
export { CONSENT_VERSION, CONSENT_METHOD, CONSENT_PURPOSE };
